/**
 * Form Component for our Return details sidebar that
 * lets users edit the details of a customer like
 * email, name and address.
 *
 * @component
 */

import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
} from 'antd';
import { EditTwoTone, DeleteTwoTone } from '@ant-design/icons';
import axios from 'axios';
import React, { Component } from 'react';
import { SubscriptionContext } from '../../../../../contexts/SubscriptionContext';

const FormItem = Form.Item;
const { Option } = Select;

class ReturnMultipleAddress extends Component {
  static contextType = SubscriptionContext;

  constructor(props) {
    super(props);
    this.state = {
      countriesList: [],
      storeAddress: [],
      editStoreAddress: null,
      isSelectable: null,
      defaultAddress: null,
      locationName: undefined,
      fullName: undefined,
      company: undefined,
      streetAddress: undefined,
      country: undefined,
      optional: undefined,
      city: undefined,
      state: undefined,
      zipCode: undefined,
      email: undefined,
      phone: undefined,
      loading: false,
    };
  }
  formRef = React.createRef();

  async getStoreAddresses() {
    try {
      const response = await axios.get('/api/returnSettings/multipleAddress');
      const storeAddress = response.data.getStoreAddress;
      const filterAddress = storeAddress.find((e) => {
        return e.defaultActive === true;
      });
      this.setState({
        storeAddress,
        isSelectable: filterAddress,
        defaultAddress: filterAddress.id,
      });
    } catch (err) {
      console.log('Error, Unable to get get store Address.Please try again.');
    }
  }

  async componentDidMount() {
    this.getStoreAddresses();
    this.setState({
      countriesList: this.props.countriesList,
    });
  }

async componentDidUpdate(prevProps) {
  if (this.props.updateProps && this.props.updateProps !== prevProps.updateProps) {
    await this.getStoreAddresses();
  }
}

  handleCancel = () => {
    this.props.showAddressModal();
    this.props.handleChangeMultipleAddress(
      this.state.defaultAddress,
      this.state.storeAddress
    );
    this.setState({
      locationName: null,
      fullName: null,
      company: null,
      streetAddress: null,
      country: null,
      optional: null,
      city: null,
      zipCode: null,
      state: null,
      email: null,
      phone: null,
    });
  };

  toggleModal = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };

  handleSubmit = async () => {
    try {
      this.setState({ loading: true });
      const values = await this.formRef.current.validateFields();

      const response = await axios.post(
        '/api/returnSettings/multipleAddress/create',
        { values }
      );

      if (response.data.status === 'error') {
        this.setState({ loading: false });
        return message.error(
          'Error, Unable to add store address, Please try again.',
          5
        );
      }

      await this.context.updateContext();

      if (response.data.status === 'Success') {
        this.props.showAddressModal();
        this.getStoreAddresses();this.setState({ loading: false });
        return message.success('Store Address Added Successfully.', 5);
      }
    } catch (err) {
      this.setState({ loading: false });
      return message.error(
        'Error, Unable to add store address, Please try again.'
      );
    }
  };

  editStoreAddress = async (e, id) => {
    try {
      const values = await this.formRef.current.validateFields();

      const response = await axios.post(
        `/api/returnSettings/multipleAddress/edit/${id}`,
        { values }
      );

      if (response.data.status === 'error') {
        return;
      }

      this.handleCancel();
      this.props.handleChangeMultipleAddress(
        this.state.defaultAddress,
        this.state.storeAddress
      );
      this.getStoreAddresses();return message.success('Store Address Added Successfully.', 5);
    } catch (err) {
      return message.error('Error, Unable to add store address, Please try again.');
    }
  };

  saveDefaultStoreAddress = async () => {
    try {
      const values = await this.formRef.current.validateFields();
      values.defaultActive = true;

      const response = await axios.post(
        '/api/returnSettings/multipleAddress/create',
        { values }
      );

      if (response.data.status === 'error') {
        return message.error(
          'Error, Unable to add store address, Please try again.',
          5
        );
      }

      await this.context.updateContext();

      if (response.data.status === 'Success') {
        this.props.showAddressModal();
        this.props.getReturnSettings();
        this.getStoreAddresses();
        return message.success('Store Address Added Successfully.', 5);
      }
    } catch (err) {
      if (err.errorFields) return;
      return message.error('Error, Unable to add store address, Please try again.');
    }
  };

  handleEditStoreAddress = async (id) => {
    this.props.showAddressModal();

    const storeAddress = this.state.storeAddress.filter((e) => {
      return e.id === id;
    });

    this.setState({
      isSelectable: id,
      editStoreAddress: id,
    });

    storeAddress &&
      storeAddress.map((address) => {
        this.setState({
          locationName: address.locationName,
          fullName: address.fullName,
          company: address.company,
          streetAddress: address.streetAddress,
          country: address.country,
          optional: address.optional,
          city: address.city,
          zipCode: address.zipCode,
          state: address.state,
          email: address.email,
          phone: address.phone,
        });
      });
  };

  deleteStoreAddress = async (id) => {
    try {
      const response = await axios.post(
        `/api/returnSettings/multipleAddress/remove/${id}`
      );

      if (response.data.status === 'error') {
        return message.error(
          'Error, Unable to remove store address, Please try again.',
          5
        );
      }await this.context.updateContext();
      this.getStoreAddresses();
      this.props.getReturnSettings();
      this.props.handleChangeMultipleAddress(
        this.state.defaultAddress,
        this.state.storeAddress
      );
      return message.success('Store Address remove successfully.', 5);
    } catch (err) {
      message.error('Error, unable to delete store address.', 5);
    }
  };

  render() {
    return (
      <React.Fragment>
        <Select
          style={{ width: '100%', height: '38px' }}
          placeholder="Select Address"
          value={
            this.props.defaultActiveStoreAddress
              ? this.props.defaultActiveStoreAddress
              : this.state.isSelectable && this.state.isSelectable.id
          }
          onChange={(e) =>
            this.props.handleChangeMultipleAddress(e, this.state.storeAddress)
          }
        >
          {this.state.storeAddress &&
            this.state.storeAddress.length > 0 &&
            this.state.storeAddress.map((address) => (
              <Option value={address.id} key={address.id}>
                {address.locationName}

                {this.props.defaultActiveStoreAddress !== address.id &&
                  !address.defaultActive && (
                  <div style={{ float: 'right' }}>
                    <EditTwoTone onClick={() => this.handleEditStoreAddress(address.id)} />
                      &#160; &#160;
                    <Popconfirm
                      title="Are you sure delete this store address?"
                      onConfirm={() => this.deleteStoreAddress(address.id)}
                      onCancel={() => this.handleCancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <DeleteTwoTone twoToneColor="#FF0000" />
                    </Popconfirm>
                  </div>
                )}
              </Option>
            ))}
        </Select>
        {this.props.visible && (
          <Modal
            title={
              this.state.editStoreAddress
                ? 'Update Customer shipping details'
                : 'Add Customer shipping details'
            }
            visible={true}
            onCancel={this.handleCancel}
            footer={[
              <Button
                key="back"
                onClick={this.handleCancel}
                className="u-marginTop--md"
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                disabled={this.state.loading}
                onClick={
                  this.state.editStoreAddress
                    ? (e) =>
                      this.editStoreAddress(e, this.state.editStoreAddress)
                    : (e) => this.handleSubmit(e)
                }
                className="u-marginTop--md"
              >
                Save changes
              </Button>,
              !this.state.editStoreAddress && (
                <Button
                  key="defaultSave"
                  type="primary"
                  onClick={this.saveDefaultStoreAddress}
                  disabled={this.state.loading}
                  className="u-marginTop--md"
                >
                  Save as default
                </Button>
              ),
            ]}
          >
            <Form ref={this.formRef}>
              <Row>
                <Col span={24}>
                  <h4>Select country</h4>
                  <FormItem
                    name="country"
                    initialValue={this.state.country}
                    rules={[{ required: true, message: 'Country is required' }]}
                  >
                    <Select placeholder="Select country" className="u-marginBottom--sm">
                      {this.state.countriesList}
                    </Select>
                  </FormItem>

                  <h4>Store name</h4>
                  <FormItem
                    name="locationName"
                    initialValue={this.state.locationName}
                    rules={[{ required: true, message: 'Store name is required' }]}
                  >
                    <Input placeholder="Store name" className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>Full name</h4>
                  <FormItem
                    name="fullName"
                    initialValue={this.state.fullName}
                    rules={[{ required: true, message: 'Full name is required' }]}
                  >
                    <Input placeholder="Full name" className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>Company</h4>
                  <FormItem
                    name="company"
                    initialValue={this.state.company}
                    rules={[{ required: true, message: 'Company is required' }]}
                  >
                    <Input placeholder="Company" className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>Address</h4>
                  <FormItem
                    name="streetAddress"
                    initialValue={this.state.streetAddress}
                    rules={[{ required: true, message: 'Address is required' }]}
                  >
                    <Input placeholder="Street and number, P.O. box, c/o." className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>Address line 2</h4>
                  <FormItem
                    name="optional"
                    initialValue={this.state.optional}
                  >
                    <Input placeholder="Apartment, suite, unit, building, floor, etc." className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>City</h4>
                  <FormItem
                    name="city"
                    initialValue={this.state.city}
                    rules={[{ required: true, message: 'City is required' }]}
                  >
                    <Input placeholder="City" className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>State / Province / Region</h4>
                  <FormItem
                    name="state"
                    initialValue={this.state.state}
                    rules={[{ validator: this.handleStateValidator }]}
                  >
                    <Input placeholder="State / Province / Region" className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>Zip code</h4>
                  <FormItem
                    name="zipCode"
                    initialValue={this.state.zipCode}
                    rules={[{ required: true, message: 'Zip code is required' }]}
                  >
                    <Input placeholder="Zip Code" className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>Phone</h4>
                  <FormItem
                    name="phone"
                    initialValue={this.state.phone}
                    rules={[{ required: true, message: 'Phone is required' }]}
                  >
                    <Input placeholder="May be used to assist delivery" className="u-marginBottom--sm" />
                  </FormItem>

                  <h4>Email</h4>
                  <FormItem
                    name="email"
                    initialValue={this.state.email}
                    rules={[{ required: true, message: 'Email is required' }]}
                  >
                    <Input placeholder="May be used to assist delivery" className="u-marginBottom--sm" />
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

export default ReturnMultipleAddress;
